import type { ChatEntranceUseCaseData } from "~vue/types/chat";

export enum ChatUseCaseLocation {
    DISCOVER_HOMEPAGE = "discover_homepage",
    PEOPLE_DETAIL_DISCOVER_MODULE = "people_detail_discover_module",
}

export enum ChatUseCaseDisplayVariant {
    BUTTON = "button",
    CARD = "card",
}

export function isRolePlayUseCase(use_case: ChatEntranceUseCaseData): boolean {
    return use_case.is_roleplay;
}

export function makeUseCasesShownLogData(variant: ChatUseCaseDisplayVariant, location: ChatUseCaseLocation, useCases: ChatEntranceUseCaseData[]) {
    return {
        labels: useCases.map((useCase) => useCase.label),
        call_codes: useCases.map((useCase) => useCase.call_code),
        chat_sources: useCases.map((useCase) => useCase.chat_source),
        descriptions: useCases.map((useCase) => useCase.description),
        variant,
        location,
    };
}
